<template>
  <H5 v-if="isMobile" />
  <PC v-else />
</template>

<script lang="ts" setup>
import { ENUM_PageName, E_RECOMMEND_CATEGORY } from '~/enums'
import PC from '~/pages/desktop/attractions/detail/index.vue'
import H5 from '~/pages/mobile/attractions/detail/index.vue'
import ogImageUrl from '~/assets/logo.png'

definePageMeta({
  pageCategory: ENUM_PageName.Detail,
})
const isMobile = useMobileByScreen()
const commonStore = useCommonStore()

const {
  attrBasicInfo,
  attrId,
  getAttrProducts,
  getAttrResponse,
  watchMobile,
  initFilter,
  trackViewItem,
  addScrollListener,
} = useAttractionDetail()

const { t } = useI18n()
const { addRecentViewdStore } = useSearchResult()

const userStore = useUserStore()
const filterConditionsStore = useFilterConditionsStore()
initFilter()
useAutoScrollTop()
const { refresh } = await useAsyncData('attrListGroupedProductPost', getAttrProducts)

useSeoMeta({
  title: () => t('key.detail.page.meta.title.new', [attrBasicInfo.value?.attrName]),
  keywords: () => t('key.detail.page.meta.keywords.new', [attrBasicInfo.value?.attrName]),
  description: () => t('key.detail.page.meta.desc.new', [attrBasicInfo.value?.attrName]),
  ogImageUrl,
})

watch([
  () => filterConditionsStore.filterConditions.detailFilterIdList,
  () => filterConditionsStore.getRequestFilterConditions().detailDate,
  () => userStore.userInfo.currency,
], () => {
  refresh()
})

if (!commonStore.commonData.cityInfo?.attrDestinationList?.length) {
  await commonStore.getCityList()
}

await getAttrResponse()
watchMobile()

onMounted(() => {
  trackViewItem()
  addScrollListener()
  addRecentViewdStore(`${attrId.value}`, E_RECOMMEND_CATEGORY.ATTR)
})
</script>
